import moment from 'moment'
import React, { useState } from 'react'
import {
  IconEditSvg,
  IconTrashSvg,
  PinSvg
} from '../../../assets/icons/svgComponents'
import * as S from '../style'
import 'moment/locale/pt-br'
import theme from '../../../styles/theme'
import { RelevantFactModel } from '../../../../domain/models/relevant-fact'
import { CustomerModel, ServiceModelDto } from '../../../../domain/models'
import { useModalBox } from '../../../contexts'
import DeleteRelevantFact from '../../accordion-table/delete-relevant-fact'
import FactForm, { formatDate } from '../modal/fact'

type PageProps = {
  relevantFact: RelevantFactModel
  patient: CustomerModel | undefined
  service: ServiceModelDto
}

const FactCard = ({
  relevantFact,
  patient,
  service
}: PageProps): JSX.Element => {
  const { modalBox } = useModalBox()
  const [openActions, setOpenActions] = useState<boolean>(false)
  const handleOpenDeleteServiceModal = () => {
    modalBox(
      <DeleteRelevantFact item={relevantFact} />,
      'Deletar Fato Relevante',
      '35%'
    )
  }

  const handleOpenRelevantFactModal = () => {
    if (relevantFact) {
      modalBox(
        <FactForm
          cdServiceProps={Number(service.cdServico)}
          relevantFact={relevantFact}
        />,
        'Validação de dados',
        '46%'
      )
    }
  }
  console.log(relevantFact)
  return (
    <S.ContainerCard color={theme.colors.blue}>
      <S.IconTop color={theme.colors.blue}>
        <PinSvg outlined />
      </S.IconTop>
      <S.Title>
        {relevantFact.titulo}
        <S.Options
          onClick={() => {
            setOpenActions((prev: boolean) => !prev)
          }}
        >
          {openActions && (
            <S.DropdownAction>
              <span>
                <S.ActionButtonCard
                  onClick={() => handleOpenRelevantFactModal()}
                >
                  <IconEditSvg /> Editar
                </S.ActionButtonCard>
                <S.ActionButtonCardCancel
                  onClick={() => handleOpenDeleteServiceModal()}
                >
                  <IconTrashSvg /> Excluir
                </S.ActionButtonCardCancel>
              </span>
            </S.DropdownAction>
          )}
          ...
        </S.Options>
      </S.Title>
      <S.SubTitle>
        {moment(formatDate(relevantFact.dataFatoRelevante))
          .locale('pt-br')
          .format('DD [de] MMMM [de] YYYY')}
      </S.SubTitle>
      <S.Paragraph>
        <span>{relevantFact.descricao}</span>
        <S.SeeMore
          to={`/meus-pacientes/${patient?.cdCliente}/${service.cdServico}/fato-relevante/${relevantFact.cdFatoRelevante}`}
        >
          Ver mais
        </S.SeeMore>
      </S.Paragraph>
    </S.ContainerCard>
  )
}
export default FactCard
